package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.language.LocalText

import com.anjuros.website.templates.selection.styles.HeaderHeight

import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.components.Template8Header
import com.anjuros.website.templates.template8.styles.Template8LearnMoreWidthStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8LearnMoreSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuCLicked: () -> Unit
) {
    Box(
        modifier = modifier
            .backgroundColor(Template8Theme.Gold3.rgb)
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template8Header(
                onMenuCLicked = onMenuCLicked
            )
            GoldLine()

            Template8LearnMore()
        }
        AnjurosLogo(
            modifier = Modifier

                .align(Alignment.TopCenter)
                .margin(top = 20.px)
                .size(150.px)
                .objectFit(ObjectFit.ScaleDown),
            src = Template8Res.Image.template8_logo,
            alt = "Pub menu"
        )

    }
}

@Composable
fun Template8LearnMore(){
    var animatedOpacity = remember { mutableStateOf(0.0f) }
    var scope = rememberCoroutineScope()

    scope.launch {
        delay(300)
        animatedOpacity.value = 1.0f
    }
        Box(
        modifier = Modifier.fillMaxWidth()

    ) {
        AnjurosImage(
            modifier = Modifier
                .fillMaxWidth()
                .displayIfAtLeast(Breakpoint.LG)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_info2,
            alt = "Pub menu"
        )

        Box(
            modifier = Template8LearnMoreWidthStyle.toModifier()
                .align(Alignment.Center)
                .backgroundColor(Template8Theme.DarkGrey.rgb)
        ) {


            Column(
                modifier = Modifier.fillMaxWidth()
                    .padding(30.px)
                    .align(Alignment.Center),
                verticalArrangement = Arrangement.spacedBy(20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Template8LearnMoreText(
                    text = ResKey.TEMPLATE8_ABOUT1,
                    animatedOpacity = animatedOpacity.value,
                    delay = 400)
                Template8LearnMoreText(
                    text = ResKey.TEMPLATE8_ABOUT2,
                    animatedOpacity = animatedOpacity.value,
                    delay = 900)
                Template8LearnMoreText(
                    text = ResKey.TEMPLATE8_ABOUT3,
                    animatedOpacity = animatedOpacity.value,
                    delay = 1400)


            }
        }
    }
}


@Composable
fun Template8LearnMoreText(text:ResKey,
                           animatedOpacity: Float,
                           delay:Int){
    P(
        attrs = Modifier
            .opacity(animatedOpacity)
            .transition(Transition.of(property = "opacity", duration = 1500.ms, delay = delay.ms))
            .margin(topBottom = 0.px)
            .textAlign(TextAlign.Justify)
            .fontFamily(FONT_FAMILY)
            .fontSize(20.px)
            .fontWeight(FontWeight.Normal)
            .fontStyle(FontStyle.Italic)
            .color(Template8Theme.Primary.getColor())
            .toAttrs()
    ) {
        Text(LocalText(text))
    }
}